/**
 * @Description 集客点地图展示
 */
import { showMarker } from '@/common/utils/map';
import { useEffect, useRef } from 'react';
import styles from '../index.module.less';
const GatherClientMap = ({
  mapIns,
  gatherClientLegendList,
}) => {
  const markerListRef = useRef<any[]>([]);
  useEffect(() => {
    if (!mapIns) return;

    gatherClientLegendList?.forEach((info, index) => {
      // 绘制线
      if (info?.moveLineList?.length) {
        drawLine(info.moveLineList, index);
        return;
      }
      // 绘制文本标记
      if (info.lng && info.lat) {
        drawPoint(info, index);
      }
    });
    return () => {
      markerListRef.current.forEach(item => {
        mapIns?.remove(item);
      });
    };
  }, [mapIns, gatherClientLegendList]);

  const drawLine = (moveLineList, index) => {
    moveLineList?.map((line) => {
      const lineMarker = new window.AMap.Polyline({
        path: line.map((item) => [item.lng, item.lat]),
        strokeColor: '#16dee1',
        strokeOpacity: 1,
        strokeWeight: 6,
        strokeStyle: 'solid',
        lineJoin: 'round', // 折线拐点
        lineCap: 'round', // 折线两端
        showDir: true,
        zIndex: 100,
      });
      markerListRef.current.push(lineMarker);
      mapIns.add(lineMarker);


      const pointMarker = new window.AMap.Marker({
        position: [line[line.length - 1]?.lng, line[line.length - 1]?.lat],
        anchor: 'bottom-center',
      });
      markerListRef.current.push(pointMarker);
      mapIns.add(pointMarker);
      showMarker(pointMarker, <Point index={index}/>);
    });


  };

  const drawPoint = (info, index) => {
    const iconMarker = new window.AMap.Marker({
      position: [+info.lng, +info.lat],
      anchor: 'center',
    });
    mapIns.add(iconMarker);
    showMarker(iconMarker, <Point index={index} needCircle={true}/>);
    markerListRef.current.push(iconMarker);
  };

  return <div>

  </div>;
};
export default GatherClientMap;
const Point = ({
  index,
  needCircle = false,
}) => {
  return <div className={styles.point}>
    {needCircle ? <div className={styles.circle}></div> : <></>}
    <div className={styles.text}>集{index + 1}</div>
    <img src='https://staticres.linhuiba.com/project-custom/locationpc/selectionmap/sitemap_gatherclient_pointNew.png'/>
  </div>;
};
